import { useEffect } from "react";
import NutritionPackagesPage from "@/containers/NutritionPackagesPage";
import { renderMetaData } from "@/utils";
//Redux
import { wrapper } from "@/redux/Store";
import * as dashboardActions from "@/redux/DashboardReducer";
import * as actions from "@/redux/HealthProgramV1Reducer";

import { useAppDispatch } from "@/hooks";

const NutritionPackagePage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(
      actions.getHealthLandingPageV1({
        slug: "nutrition-for-kids",
      })
    );
  }, [dispatch]);

  const h1Text = "Nutrition for Kids";

  const metaData = {
    siteName: "Shyft",
    siteURL: "https://www.betheshyft.com/nutrition-for-kids",
    title:
      "Nutrition plans for Kids by experienced nutritionists | Shyft health",
    description:
      "Nutrition plans for kids from certified and experienced nutritionists. Get one on one consultations.",
    thumbnail: "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/logo-c305d1c2dc6e4a9cb2d7767c4d9c213b.png",
    h1Text,
  };

  const metaTags = renderMetaData(metaData);

  return (
    <>
      {metaTags}
      <main>
        <NutritionPackagesPage h1Text={h1Text} />
      </main>
    </>
  );
};

export default NutritionPackagePage;

export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async () => {
    await store.dispatch(
      dashboardActions.getRibbonData({ pathname: "nutrition-for-kids" })
    );
    const res = await store.dispatch(
      actions.getHealthLandingPageV1({
        slug: "nutrition-for-kids",
      })
    );
    if (!res?.payload) {
      return {
        notFound: true,
      };
    }
  }
);
